<!-- Backdrop -->
<div class="modal-backdrop" data-testid="modal-backdrop" *ngIf="isOpen" (click)="fecharModal(false)"></div>

<!-- Modal container -->
<div class="modal-container" data-testid="venda-modal-v2" *ngIf="isOpen" role="dialog" aria-modal="true" (click)="$event.stopPropagation()">

  <!-- ── Header ──────────────────────────────────────────────────────────── -->
  <div class="modal-header">
    <div class="modal-header-left">
      <span class="modal-eyebrow">{{ tipoAcao === 'NOVA_VENDA' ? 'Fechar Venda v2' : 'Baixar Parcela v2' }}</span>
      <h2 class="modal-title">
        {{ tipoAcao === 'NOVA_VENDA' ? 'Finalizar Orçamento' : 'Adicionar Pagamento' }}
      </h2>
    </div>
    <button class="modal-close" data-testid="modal-fechar" (click)="fecharModal(false)" [disabled]="isLoading" aria-label="Fechar">x</button>
  </div>

  <!-- ── Banner de dados do orçamento / venda ─────────────────────────────── -->
  <div class="orcamento-banner" *ngIf="tipoAcao === 'NOVA_VENDA' && orcamento">
    <div class="banner-item">
      <span class="banner-label">Orçamento</span>
      <span class="banner-value mono">#{{ orcamento.id }}</span>
    </div>
    <div class="banner-divider"></div>
    <div class="banner-item grow">
      <span class="banner-label">Cliente</span>
      <span class="banner-value">{{ orcamento.nomeCliente }}</span>
    </div>
    <div class="banner-divider"></div>
    <div class="banner-item">
      <span class="banner-label">Valor Total</span>
      <span class="banner-value valor">{{ orcamento.valorTotal | currency:'BRL':'symbol':'1.2-2' }}</span>
    </div>
  </div>

  <div class="orcamento-banner" *ngIf="tipoAcao === 'BAIXAR_PARCELA' && venda">
    <div class="banner-item">
      <span class="banner-label">Orçamento</span>
      <span class="banner-value mono">#{{ venda.idOrcamento }}</span>
    </div>
    <div class="banner-divider"></div>
    <div class="banner-item grow">
      <span class="banner-label">Total da Venda</span>
      <span class="banner-value">{{ venda.totalVenda | currency:'BRL':'symbol':'1.2-2' }}</span>
    </div>
    <div class="banner-divider"></div>
    <div class="banner-item">
      <span class="banner-label">Saldo Devedor</span>
      <span class="banner-value valor">{{ venda.saldoDevedor | currency:'BRL':'symbol':'1.2-2' }}</span>
    </div>
  </div>

  <!-- Aviso de cliente com restrição (apenas nova venda) -->
  <div class="restricao-banner" data-testid="banner-restricao" *ngIf="clienteComRestricao && tipoAcao === 'NOVA_VENDA'">
    <span class="restricao-icon">!</span>
    <span>Cliente com restrição ativa. Venda parcelada e venda mista bloqueadas preventivamente. Apenas venda à vista autorizada.</span>
  </div>

  <!-- ── Barra de progresso ────────────────────────────────────────────────── -->
  <div class="progress-bar-wrapper">
    <div class="progress-bar">
      <ng-container *ngFor="let s of progressSteps; let i = index; let last = last">
        <div class="progress-step"
             [class.active]="isStepAtivo(s.key)"
             [class.done]="isStepConcluido(s.key)">
          <div class="step-circle">{{ isStepConcluido(s.key) ? '✓' : getStepNumero(s.key) }}</div>
          <span class="step-label">{{ s.label }}</span>
        </div>
        <div class="progress-connector" *ngIf="!last" [class.done]="isStepConcluido(s.key)"></div>
      </ng-container>
    </div>
  </div>

  <!-- ── Corpo do wizard ────────────────────────────────────────────────────── -->
  <div class="modal-body">

    <!-- Mensagem de erro inline -->
    <div class="error-msg" data-testid="erro-inline" *ngIf="hasError && errorMsg">
      <span class="error-icon">!</span>
      <span>{{ errorMsg }}</span>
      <span *ngIf="!isDocValido" class="doc-invalido-hint">
        &mdash; Atualize o cadastro do cliente antes de prosseguir.
      </span>
    </div>

    <!-- ══════════════════ PASSO: TIPO DE VENDA ══════════════════ -->
    <div class="step-panel" data-testid="step-tipo" *ngIf="step === 'tipo'">
      <p class="step-hint">Selecione o tipo de venda:</p>
      <div class="tipo-grid">
        <button
          *ngFor="let t of tiposVendaOpcoes"
          class="tipo-card"
          [attr.data-testid]="'tipo-' + t.value"
          [class.selected]="tipoVendaSelecionado === t.value"
          [disabled]="t.desativado"
          [title]="t.tooltipDesativado ?? ''"
          (click)="selecionarTipo(t.value)">
          <span class="tipo-label">{{ t.label }}</span>
          <span class="tipo-desc">{{ t.descricao }}</span>
          <span class="tipo-disabled-hint" *ngIf="t.desativado && t.tooltipDesativado">
            {{ t.tooltipDesativado }}
          </span>
        </button>
      </div>
    </div>

    <!-- ══════════════════ PASSO: FORMA DE PAGAMENTO ══════════════════ -->
    <div class="step-panel" data-testid="step-forma" *ngIf="step === 'forma'">
      <p class="step-hint">Selecione a forma de pagamento:</p>
      <div class="forma-grid">
        <button
          *ngFor="let f of formasDisponiveis"
          class="forma-card"
          [attr.data-testid]="'forma-' + f.value"
          [class.selected]="formaSelecionada === f.value"
          (click)="selecionarForma(f.value)">
          {{ f.label }}
        </button>
      </div>
      <div class="step-actions">
        <button class="btn-voltar" data-testid="btn-voltar" type="button" (click)="voltarStep()">Voltar</button>
      </div>
    </div>

    <!-- ══════════════════ PASSO: NUMERO DE PARCELAS ══════════════════ -->
    <div class="step-panel" data-testid="step-parcelas" *ngIf="step === 'parcelas'">
      <p class="step-hint">Número de parcelas:</p>
      <div class="parcelas-select-wrapper">
        <select class="parcelas-select" data-testid="select-parcelas" [(ngModel)]="numParcelas">
          <option *ngFor="let p of parcelasOpcoes" [value]="p">{{ p }}x</option>
        </select>
      </div>
      <div class="step-actions">
        <button class="btn-voltar" data-testid="btn-voltar" type="button" (click)="voltarStep()">Voltar</button>
        <button class="btn-avancar" data-testid="btn-avancar" type="button" (click)="confirmarParcelas()" [disabled]="isLoading">Continuar</button>
      </div>
    </div>

    <!-- ══════════════════ PASSO: BANDEIRA DO CARTAO ══════════════════ -->
    <div class="step-panel" data-testid="step-bandeira" *ngIf="step === 'bandeira'">
      <p class="step-hint">Selecione a bandeira do cartão:</p>
      <div class="bandeira-grid">
        <button
          *ngFor="let b of bandeiras"
          class="bandeira-card"
          [attr.data-testid]="'bandeira-' + b.value"
          [class.selected]="bandeiraCartao === b.value"
          (click)="bandeiraCartao = b.value; hasError = false">
          {{ b.label }}
        </button>
      </div>
      <div class="step-actions">
        <button class="btn-voltar" data-testid="btn-voltar" type="button" (click)="voltarStep()">Voltar</button>
        <button class="btn-avancar" data-testid="btn-avancar" type="button" (click)="confirmarBandeira()" [disabled]="isLoading">Continuar</button>
      </div>
    </div>

    <!-- ══════════════════ PASSO: VALOR DE ENTRADA (VENDA MISTA) ══════════════════ -->
    <div class="step-panel" data-testid="step-entrada" *ngIf="step === 'entrada'">
      <p class="step-hint">Informe o valor de entrada:</p>

      <div class="entrada-group" *ngIf="orcamento">
        <label class="entrada-label">Valor de entrada (R$)</label>
        <input
          class="entrada-input"
          data-testid="input-valor-entrada"
          type="number"
          [(ngModel)]="valorEntrada"
          min="0.01"
          [max]="orcamento.valorTotal - 0.01"
          step="0.01"
          placeholder="0,00">

        <div class="saldo-info">
          <span>Saldo a receber após entrada:</span>
          <strong data-testid="saldo-a-receber">{{ saldoAReceber | currency:'BRL':'symbol':'1.2-2' }}</strong>
        </div>
        <p class="entrada-hint">
          Valor total do orçamento: {{ orcamento.valorTotal | currency:'BRL':'symbol':'1.2-2' }}.
          A entrada deve ser maior que R$ 0,00 e menor que o valor total.
        </p>
      </div>

      <div class="step-actions">
        <button class="btn-voltar" data-testid="btn-voltar" type="button" (click)="voltarStep()">Voltar</button>
        <button class="btn-avancar" data-testid="btn-avancar" type="button" (click)="confirmarEntrada()" [disabled]="isLoading">Continuar</button>
      </div>
    </div>

    <!-- ══════════════════ PASSO: CONFIRMACAO ══════════════════ -->
    <div class="step-panel" data-testid="step-confirmacao" *ngIf="step === 'confirmacao'">

      <!-- Confirmacao: NOVA_VENDA -->
      <ng-container *ngIf="tipoAcao === 'NOVA_VENDA' && orcamento">
        <p class="step-hint">Revise e confirme a venda:</p>

        <div class="confirmacao-grid">
          <div class="conf-row">
            <span class="conf-label">Orçamento</span>
            <span class="conf-value mono" data-testid="conf-orcamento">#{{ orcamento.id }}</span>
          </div>
          <div class="conf-row">
            <span class="conf-label">Cliente</span>
            <span class="conf-value" data-testid="conf-cliente">{{ orcamento.nomeCliente }}</span>
          </div>
          <div class="conf-row">
            <span class="conf-label">Tipo de venda</span>
            <span class="conf-value" data-testid="conf-tipo-venda">{{ labelTipoVenda }}</span>
          </div>
          <div class="conf-row">
            <span class="conf-label">Forma de pagamento</span>
            <span class="conf-value" data-testid="conf-forma">{{ labelFormaSelected }}</span>
          </div>
          <div class="conf-row" *ngIf="bandeiraCartao">
            <span class="conf-label">Bandeira</span>
            <span class="conf-value" data-testid="conf-bandeira">{{ bandeiraCartao }}</span>
          </div>
          <div class="conf-row" *ngIf="isParcelado">
            <span class="conf-label">Parcelas</span>
            <span class="conf-value" data-testid="conf-parcelas">{{ numParcelas }}x</span>
          </div>
          <div class="conf-row" *ngIf="tipoVendaSelecionado === TIPO_VENDA_MISTA">
            <span class="conf-label">Valor da entrada</span>
            <span class="conf-value valor" data-testid="conf-valor-entrada">{{ valorEntrada | currency:'BRL':'symbol':'1.2-2' }}</span>
          </div>
          <div class="conf-row" *ngIf="tipoVendaSelecionado === TIPO_VENDA_MISTA">
            <span class="conf-label">Saldo a receber</span>
            <span class="conf-value" data-testid="conf-saldo-a-receber">{{ saldoAReceber | currency:'BRL':'symbol':'1.2-2' }}</span>
          </div>
          <div class="conf-row valor-total">
            <span class="conf-label">Valor total</span>
            <span class="conf-value valor" data-testid="conf-valor-total">{{ orcamento.valorTotal | currency:'BRL':'symbol':'1.2-2' }}</span>
          </div>
        </div>

        <!-- Previsao de entrega -->
        <div class="entrega-section">
          <label class="entrega-label">Previsão de entrega</label>
          <div class="entrega-controls">
            <div class="entrega-dias">
              <input
                class="entrega-input-num"
                data-testid="input-dias-corridos"
                type="number"
                [(ngModel)]="diasCorridos"
                [min]="prazoMinimo"
                [max]="prazoMaximo"
                (change)="onDiasCorridosChange()">
              <span class="entrega-dias-label">dias corridos</span>
            </div>
            <input
              class="entrega-input-date"
              data-testid="input-previsao-entrega"
              type="date"
              [(ngModel)]="previsaoEntrega"
              [min]="dataMinEntrega"
              (change)="onPrevisaoEntregaChange()">
          </div>
          <p class="entrega-hint">Mínimo {{ prazoMinimo }} dias, máximo {{ prazoMaximo }} dias corridos.</p>
        </div>
      </ng-container>

      <!-- Confirmacao: BAIXAR_PARCELA -->
      <ng-container *ngIf="tipoAcao === 'BAIXAR_PARCELA' && venda">
        <p class="step-hint">Revise e confirme o pagamento:</p>

        <!-- Campo de valor a baixar -->
        <div class="entrada-group">
          <label class="entrada-label">Valor a pagar (R$)</label>
          <input
            class="entrada-input"
            data-testid="input-valor-baixar"
            type="number"
            [(ngModel)]="valorABaixar"
            min="0.01"
            [max]="venda.saldoDevedor"
            step="0.01"
            placeholder="0,00">
        </div>

        <div class="confirmacao-grid">
          <div class="conf-row">
            <span class="conf-label">Orçamento vinculado</span>
            <span class="conf-value mono" data-testid="conf-orcamento">#{{ venda.idOrcamento }}</span>
          </div>
          <div class="conf-row">
            <span class="conf-label">Total da venda</span>
            <span class="conf-value" data-testid="conf-total-venda">{{ venda.totalVenda | currency:'BRL':'symbol':'1.2-2' }}</span>
          </div>
          <div class="conf-row">
            <span class="conf-label">Saldo devedor atual</span>
            <span class="conf-value valor" data-testid="conf-saldo-devedor">{{ venda.saldoDevedor | currency:'BRL':'symbol':'1.2-2' }}</span>
          </div>
          <!--
            Disponível para lançar só aparece quando diverge do saldo devedor —
            ou seja, quando já há pagamento parcelado em aberto. Nas demais
            vendas os dois números são iguais e exibir ambos só confundiria.
          -->
          <div class="conf-row" *ngIf="disponivelDivergeDoSaldo" data-testid="conf-row-disponivel">
            <span class="conf-label">
              Disponível para lançar
              <small class="text-muted d-block">Total da venda menos o que já foi comprometido em parcelas</small>
            </span>
            <span class="conf-value valor" data-testid="conf-valor-disponivel">{{ valorDisponivel | currency:'BRL':'symbol':'1.2-2' }}</span>
          </div>
          <div class="conf-row">
            <span class="conf-label">Valor a abater</span>
            <span class="conf-value valor" data-testid="conf-valor-abater">{{ valorABaixar | currency:'BRL':'symbol':'1.2-2' }}</span>
          </div>
          <div class="conf-row valor-total">
            <span class="conf-label">Novo saldo devedor</span>
            <span class="conf-value valor" data-testid="conf-novo-saldo-devedor">{{ novoSaldoDevedor | currency:'BRL':'symbol':'1.2-2' }}</span>
          </div>
          <div class="conf-row">
            <span class="conf-label">Forma de pagamento</span>
            <span class="conf-value" data-testid="conf-forma">{{ labelFormaSelected }}</span>
          </div>
          <div class="conf-row" *ngIf="bandeiraCartao">
            <span class="conf-label">Bandeira</span>
            <span class="conf-value" data-testid="conf-bandeira">{{ bandeiraCartao }}</span>
          </div>
          <div class="conf-row" *ngIf="isParcelado">
            <span class="conf-label">Parcelas</span>
            <span class="conf-value" data-testid="conf-parcelas">{{ numParcelas }}x</span>
          </div>
        </div>
      </ng-container>

      <div class="step-actions">
        <button class="btn-voltar" data-testid="btn-voltar" type="button" (click)="voltarStep()" [disabled]="isLoading">Voltar</button>
        <button class="btn-confirmar" data-testid="btn-confirmar" type="button" (click)="confirmar()" [disabled]="isLoading">
          <span *ngIf="!isLoading">{{ tipoAcao === 'NOVA_VENDA' ? 'Confirmar Venda' : 'Confirmar Pagamento' }}</span>
          <span *ngIf="isLoading">Processando...</span>
        </button>
      </div>
    </div>

  </div><!-- /modal-body -->
</div><!-- /modal-container -->

<!-- Modal de atualização do documento do cliente (erro de CPF/CNPJ inválido) -->
@if (tipoAcao === 'NOVA_VENDA' && orcamento) {
  <app-documento-cliente-modal
    [isOpen]="docModalAberto"
    [idCliente]="orcamento.idCliente"
    [nomeCliente]="orcamento.nomeCliente"
    (salvo)="onDocumentoSalvo()"
    (cancelado)="onDocumentoCancelado()" />
}
